var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loadError
    ? _c(
        "contentBox",
        { attrs: { loading: _vm.loading } },
        [
          _vm.communityPlan
            ? _c(
                "contentTitle",
                {
                  attrs: { label: "EDIT COMMUNITY PLAN", close: _vm.routeClose }
                },
                [
                  _c(
                    "h2",
                    { staticClass: "text-white font-weight-light pb-2" },
                    [_vm._v(_vm._s(_vm.communityPlan.name))]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.communityPlan
            ? _c(
                "contentBody",
                { attrs: { locked: _vm.token === null || !_vm.isAdmin } },
                [
                  _c("div", { staticClass: "p-3" }, [
                    _vm.token === null || !_vm.isAdmin
                      ? _c("div", { staticClass: "lock-block" }, [
                          _c(
                            "div",
                            {
                              staticClass: "row mx-0 hover-dk",
                              on: { click: _vm.routeLogin }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "col-2 text-center my-auto" },
                                [
                                  _c(
                                    "i",
                                    {
                                      staticClass:
                                        "material-icons text-light mr-3 md-36"
                                    },
                                    [_vm._v("account_box")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "py-3 col-10 pl-0 pr-3 py-3" },
                                [
                                  _c("h5", { staticClass: "mb-0 text-white" }, [
                                    _vm._v("Sign in to edit")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "h5",
                                    {
                                      staticClass:
                                        "mb-0 font-weight-light text-light"
                                    },
                                    [
                                      _vm._v(
                                        "You do not have permission to edit this record"
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.token !== null && _vm.isAdmin
                      ? _c(
                          "div",
                          { staticClass: "category-body" },
                          [
                            _vm.mode === "detailsEdit"
                              ? _c(
                                  "div",
                                  { staticClass: "section section-bold" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "section-title" },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\tEdit Details\n\t\t\t\t\t\t"
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "category-title-btn",
                                            on: {
                                              click: function($event) {
                                                return _vm.setMode(null)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "i",
                                              {
                                                staticClass:
                                                  "material-icons md-14"
                                              },
                                              [_vm._v("close")]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "section-body" }, [
                                      _c("div", { staticClass: "category" }, [
                                        _c(
                                          "div",
                                          { staticClass: "category-title" },
                                          [_vm._v("DESCRIPTION")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "property-row" },
                                          [
                                            _c("textarea", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.rec.description,
                                                  expression: "rec.description"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              attrs: { rows: "10" },
                                              domProps: {
                                                value: _vm.rec.description
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.rec,
                                                    "description",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "section-footer" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-sm btn-primary float-right",
                                            on: { click: _vm.saveDetails }
                                          },
                                          [_vm._v("Save")]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _c("div", { staticClass: "section" }, [
                                  _c("div", { staticClass: "section-title" }, [
                                    _vm._v(
                                      "\n\t\t\t\t\t\tDetails\n\t\t\t\t\t\t"
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "category-title-btn",
                                        on: {
                                          click: function($event) {
                                            return _vm.setMode("detailsEdit")
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "i",
                                          {
                                            staticClass: "material-icons md-14"
                                          },
                                          [_vm._v("edit")]
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "section-body" }, [
                                    _c("div", { staticClass: "category" }, [
                                      _c(
                                        "div",
                                        { staticClass: "category-title" },
                                        [_vm._v("DESCRIPTION")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "property-row" },
                                        [
                                          _vm.description
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-description"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.description)
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                { staticClass: "undef" },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                        ]
                                      )
                                    ])
                                  ])
                                ]),
                            _vm._v(" "),
                            _vm._l(_vm.communityPlan.references, function(
                              ref,
                              idx
                            ) {
                              return _vm.communityPlan.references
                                ? _c(
                                    "div",
                                    [
                                      _vm.mode === "referenceDelete" &&
                                      _vm.referenceDeleteInd === idx
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "section section-bold"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "section-title"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\tDelete Reference " +
                                                      _vm._s(idx + 1) +
                                                      "\n\t\t\t\t\t\t\t"
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "category-title-btn",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.setMode(
                                                            null
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons md-14"
                                                        },
                                                        [_vm._v("close")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "section-body" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "property-row"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\tAre you sure you want to delete this reference?\n\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "section-footer"
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-sm btn-danger float-right",
                                                      on: {
                                                        click:
                                                          _vm.referenceDeleteSubmit
                                                      }
                                                    },
                                                    [_vm._v("Delete")]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm.mode === "referenceEdit" &&
                                          _vm.referenceEditInd === idx
                                        ? _c("referenceForm", {
                                            attrs: {
                                              reference:
                                                _vm.communityPlan.references[
                                                  idx
                                                ],
                                              submitLabel: "Save",
                                              title:
                                                "Edit Reference " + (idx + 1)
                                            },
                                            on: {
                                              close: function($event) {
                                                return _vm.setMode(null)
                                              },
                                              submit: _vm.referenceSave
                                            }
                                          })
                                        : _c(
                                            "div",
                                            { staticClass: "section" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "section-title"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\tReference " +
                                                      _vm._s(idx + 1) +
                                                      "\n\t\t\t\t\t\t\t"
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "category-title-btn",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.referenceDelete(
                                                            idx
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons md-14"
                                                        },
                                                        [_vm._v("delete")]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "category-title-btn",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.referenceEdit(
                                                            idx
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons md-14"
                                                        },
                                                        [_vm._v("edit")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "section-body" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "category" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "category-title"
                                                        },
                                                        [_vm._v("DESCRIPTION")]
                                                      ),
                                                      _vm._v(" "),
                                                      ref.description
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "property-row"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    ref.description
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "undef"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "category" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "category-title"
                                                        },
                                                        [_vm._v("URL")]
                                                      ),
                                                      _vm._v(" "),
                                                      ref.url
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "property-row word-wrap-break"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    ref.url
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "undef"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            }),
                            _vm._v(" "),
                            _vm.mode === "referenceAdd"
                              ? _c("referenceForm", {
                                  attrs: {
                                    submitLabel: "Add",
                                    title: "Add Reference"
                                  },
                                  on: {
                                    close: function($event) {
                                      return _vm.setMode(null)
                                    },
                                    submit: _vm.referenceAdd
                                  }
                                })
                              : _c("div", { staticClass: "mb-3" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-dark btn-sm",
                                      on: {
                                        click: function($event) {
                                          return _vm.setMode("referenceAdd")
                                        }
                                      }
                                    },
                                    [_vm._v("Add Reference")]
                                  )
                                ])
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45101650", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45101650","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/community-plan/community-plan-edit.vue
// module id = null
// module chunks = 